export const AuthTooltip = {
	nodeClass: ".js-auth-tooltip",
	selectors: {
		nodes: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-tooltip")
		),
		closeBtns: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-tooltip__close")
		),
	},

	init: function () {
		// auto-open
		this.selectors.nodes.forEach((node) => this.autoOpen(node));

		// close
		this.selectors.closeBtns.forEach((btn) => {
			btn.addEventListener("click", (event) => this.close(event));
		});
	},

	autoOpen: function (node) {
		const delay = +node.dataset.autoOpen;

		if (isNaN(delay)) return;

		setTimeout(() => this.open(node.dataset.name), delay);
	},

	open: function (name) {
		const node = this.selectors.nodes.find(
			(node) => node.dataset.name === name
		);

		if (!node) return;

		node.classList.add("is-open");
	},

	close: function (event) {
		const node = event.target.closest(this.nodeClass);

		node.classList.remove("is-open");

		// create cookie
		const cookieName = node.dataset.cookieName;
		const cookieExp = +node.dataset.cookieExp;

		if (!cookieName || !cookieExp) return;

		const date = new Date();
		date.setTime(date.getTime() + cookieExp);
		document.cookie = `${cookieName}=seen; expires=${date.toUTCString()}; path=/`;
		console.log(document.cookie)
	},
};

window.AuthTooltip = AuthTooltip;
AuthTooltip.init();
